<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" app right>
      <v-list dense>
        <v-list-item link to="/">
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>{{$t('app.HOME')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/flarmcfg">
          <v-list-item-action>
            <v-icon>mdi-cog</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>{{$t('app.CONFIG_TOOL')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/about">
          <v-list-item-action>
            <v-icon>mdi-information</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>{{$t('app.ABOUT')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <template v-slot:append>
        <div class="pa-2">
          <LocaleSwitcher />
        </div>
      </template>
    </v-navigation-drawer>

    <v-app-bar app color="green" dark>
      <v-spacer></v-spacer>

      <v-toolbar-title>FlarmConfigTool</v-toolbar-title>

      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    </v-app-bar>

    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col>
            <router-view />
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <v-footer color="green" app>
      <span class="white--text">Made with ❤️in EDWN</span>
      <v-spacer></v-spacer>

      <span class="white--text">&copy; {{ new Date().getFullYear() }}</span>
    </v-footer>
  </v-app>
</template>

<script>
import LocaleSwitcher from "./components/LocaleSwitcher.vue";
export default {
  name: "LayoutsDemosBaselineFlipped",
  components: { LocaleSwitcher },
  props: {
    source: String,
  },
  data: () => ({
    drawer: null,
  }),
};
</script>
<style>
.container {
  max-width: 800px !important;
}
</style>